export default "__VITE_ASSET__CTwSbmNq__"